import { Logo } from "./Logo";
import { CNPJ, ADDRESS, HOURS, WHATSAPP_DISPLAY } from "../constants/site";

export const Footer = () => (
    <footer className="bg-graphite-dark text-white/60 pb-28 lg:pb-0" data-testid="footer">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
            <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-10">
                <div className="max-w-sm">
                    <Logo light />
                    <p className="mt-4 text-sm leading-relaxed">
                        Conserto de geladeiras e lava e seca em Uberlândia–MG. Frost Free, Inverter, Side by Side e
                        Inverse.
                    </p>
                </div>
                <dl className="grid sm:grid-cols-3 gap-8 text-sm">
                    <div>
                        <dt className="font-technical font-semibold uppercase tracking-[0.16em] text-[11px] text-brand">
                            Contato
                        </dt>
                        <dd className="mt-2.5">{WHATSAPP_DISPLAY}</dd>
                    </div>
                    <div>
                        <dt className="font-technical font-semibold uppercase tracking-[0.16em] text-[11px] text-brand">
                            Endereço
                        </dt>
                        <dd className="mt-2.5">Rua Arthur Bernardes, 928<br />Uberlândia/MG</dd>
                    </div>
                    <div>
                        <dt className="font-technical font-semibold uppercase tracking-[0.16em] text-[11px] text-brand">
                            Horários
                        </dt>
                        <dd className="mt-2.5">Seg–Sex 06h às 18h<br />Sáb 06h às 12h</dd>
                    </div>
                </dl>
            </div>
            <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs">
                <p>© {new Date().getFullYear()} REFRIGELAR · CNPJ {CNPJ}</p>
                <p data-testid="footer-address">{ADDRESS}</p>
            </div>
        </div>
    </footer>
);
